<template lang="pug">
.graph-wrapper(ref="DoubleGraph")
</template>
<script>
import DoubleGraph from "./DoubleGraph";
import dayjs from "dayjs";

export default {
  name: "DoubleGraph",
  components: {
    DoubleGraph,
  },
  props: {
    opts: {
      type: Object,
      required: true,
    },
    series: {
      required: false,
    },
  },
  watch: {
    series: {
      deep: true,
      handler(val) {
        if (val) {
          this.updateSerise(val);
        }
      },
    },
  },
  data() {
    return {
      graph: null,
    };
  },
  mounted() {
    this.initGraph();
  },
  methods: {
    initGraph() {
      this.graph = this.$echarts.init(this.$refs.DoubleGraph);
      this.graph.showLoading();
    },
    updateSerise(serise) {
      const that = this;
      const option = {
        backgroundColor: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(255, 255, 255, 0)",
            },
            {
              offset: 1,
              color: "rgba(255, 255, 255, 0)",
            },
          ],
        },
        color: ["#1A2634", "#118DEF"],
        title: {
          text: that.opts.title,
          left: "1%",
          top: "2%",
          textStyle: {
            color: "#000",
            fontWeight: "400",
          },
        },
        legend: {
          bottom: "0%",
          right: "0%",
          selectedMode: false,
          textStyle: {
            color: "#000",
          },
          icon: "bar",
          data: [
            {
              name: that.opts.legend1,
            },
            {
              name: that.opts.legend2,
            },
          ],
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "16%",
          bottom: "9%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          padding: 10,
          showTitle: false,
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0], "20%"];
          },
          backgroundColor: "rgba(245, 245, 245, 0.8)",
          axisPointer: {
            type: "line",
          },
          textStyle: {
            color: "#000",
          },
          formatter: "{b} <br/>{a0} : {c0}%<br/>{a1} : {c1}°C",
        },
        xAxis: {
          type: "category",
          maxInterval: 1,
          z: 5,
          boundaryGap: false,
          splitLine: {
            show: false,
            lineStyle: {
              color: "#eee",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#888",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#333",
            },
            show: false,
          },
        },
        yAxis: {
          z: 1,
          type: "value",
          min: 0,
          max: 100,
          axisLine: {
            lineStyle: {
              color: "#888", // 左侧边框
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#eee", // 横坐标轴
            },
          },
          axisTick: {
            show: true,
          },
          axisLabel: {
            textStyle: {
              color: "#333", // y轴文字颜色
            },
          },
        },
        series: [
          {
            name: that.opts.legend1,
            smooth: true,
            type: "line",
            markPoint: {
              data: [],
            },
            showSymbol: false,
            data: [],
            lineStyle: {
              normal: {
                color: "#1A2634",
                opacity: 1.0,
              },
            },
            // areaStyle: {
            //   normal: {
            //     color: '#3f4b83',
            //     opacity: 0.9
            //   }
            // }
          },
          {
            name: that.opts.legend2,
            smooth: true,
            type: "line",
            showSymbol: false,
            markPoint: {
              data: [],
            },
            data: [],
            lineStyle: {
              normal: {
                color: "#118DEF",
                opacity: 1.0,
              },
            },
            // areaStyle: {
            //   normal: {
            //     color: '#1d3589',
            //     opacity: 0.9
            //   }
            // }
          },
        ],
      };

      if(this.opts.useXAxisLabel === true){
        option.xAxis.axisLabel.show=true;
      }

      let $data = serise.data1;
      let $data2 = serise.data2;
      // 如果只有一位，添加一个key和value都为0
      if (Object.keys($data).length === 1) {
        $data[0] = 0;
      }
      if (Object.keys($data2).length === 1) {
        $data2[0] = 0;
      }
      let xA = [];
      let xV1 = [];
      let xV2 = [];
      // key以data1为准
      // console.log($data, $data2)
      for (let key in $data) {
        let dateKey = key;
        if (key.indexOf("T") > 0) {
          //json format date key: dataDate.
          dateKey = dayjs(key).format("MM月DD日 HH时mm分");
        } else {
          //not json format date key: StatisticsDate.
          let yearIndex = dateKey.indexOf("年");
          if (yearIndex > 0 && yearIndex < dateKey.length - 1) {
            dateKey = dateKey.substring(yearIndex + 1);
          }
        }
        xA.push(dateKey);
        xV1.push($data[key]);
      }
      for (let key in $data2) {
        xV2.push($data2[key]);
      }
      if (!xV1.length) {
        for (let key in $data2) {
          let dateKey = key;
          if (key.indexOf("T") > 0) {
            //json format date key: dataDate.
            dateKey = dayjs(key).format("MM月DD日 HH时mm分");
          } else {
            //not json format date key: StatisticsDate.
            let yearIndex = dateKey.indexOf("年");
            if (yearIndex > 0 && yearIndex < dateKey.length - 1) {
              dateKey = dateKey.substring(yearIndex + 1);
            }
          }
          xA.push(dateKey);
          xV1.push("--");
        }
      }
      if (!xV2.length) {
        // eslint-disable-next-line no-unused-vars
        for (let key in $data) {
          xV2.push("--");
        }
      }
      option.xAxis.data = xA;
      option.series[0].data = xV2;
      option.series[1].data = xV1;
      that.graph.hideLoading();
      that.graph.setOption(option);
      window.addEventListener("resize", function () {
        that.graph.resize();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.graph-wrapper {
  width: 100%;
  height: 100%;
}
</style>
